import { useFormik } from "formik";
import { useEffect, useState } from "react";

// Internal Imports
import ButtonGrid from "../../common/components/ButtonGrid/ButtonGrid";
import GroupRow from "../../common/components/GroupRow/GroupRow";
import ModalContainer from "../../common/components/ModalContainer/ModalContainer";
import SelectBox from "../../common/components/SelectBox/SelectBox";
import { COLORS } from "../../common/constants/colors";
import { useForm } from "../../contexts/form";
import useListBase from "../../hooks/useListBase";
import { useListUserGroup } from "../../hooks/useListUserGroup";
import { useListUsers } from "../../hooks/useListUsers";
import { useListDepartment } from "../../hooks/useListDepartment";
import IColumn from "../../interfaces/IColumn";
import { IFormRelated } from "../../interfaces/IForm";
import globalStyle from "../../common/styles/globalStyle.module.css";
import Paint from "../../common/components/Paint/Paint";
import MarginInput from "../../common/components/MarginInput/MarginInput";
import ModalBtnCotainer from "../../common/components/ModalBtnContainer/ModalBtnContainer";
import LoadingButton from "../../common/components/LoadingButton/LoadingButton";
import OutLineButton from "../../common/components/OutLineButton/OutLineButton";
import DetailTable from "../../common/components/DetailTable/DetailTable";
import { getListByFormID, UpdateListByFormID } from "../../services/form";
import { CompassOutlined, DeleteOutlined, FormOutlined, RollbackOutlined } from "@ant-design/icons";
import { getError, openNotification, tryCatch } from "../../common/constants/Utilities";
import { VisualizacionFormulario } from "../../common/enums/AllEnums";

interface Props {
    setRelateUserModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const RelacionarListadoUsuario = ({ setRelateUserModal }: Props) => {

    // States
    const { formQuestion } = useForm();
    const [detailUpdate, setDetailUpdate] = useState<IFormRelated>();
    const [detailPosition, setDetailPosition] = useState<number | null>(null);
    const [listFormRelated, setListFormRelated] = useState<IFormRelated[]>([]);

    const { listbase, loadingListBase } = useListBase();
    const { listDepartmentAll, loadingDeparmentAll } = useListDepartment();
    const { listUserAll, loadingUserAll } = useListUsers();
    const { listUserGroupAll, loadingUserGroupAll } = useListUserGroup();
    
    const [formLoading, setFormLoading] = useState<boolean>(false);


    // Const
    const columns: IColumn[] = [
        {
            title: 'Listado',
            dataIndex: 'listadoNombre',
        },
        
        {
            title: 'Departamento Usuario',
            dataIndex: '',
            render: (detail: IFormRelated) => (listDepartmentAll.find(dept => dept.departamentoGUID === detail.formularioListadoUsuario[0].departamentoGUID)?.nombre) || ''
        },

        {
            title: 'Usuario',
            dataIndex: '',
            render: (detail: IFormRelated) => (listUserAll.find(user => user.usuarioGUID === detail.formularioListadoUsuario[0].usuarioGUID)?.nombreUsuario) || ''
        },

        {
            title: 'Grupo Usuario',
            dataIndex: '',
            render: (detail: IFormRelated) => (listUserGroupAll.find(group => group.grupoUsuarioID === detail.formularioListadoUsuario[0].grupoUsuarioID)?.nombre) || ''
        },

        {
            title: '',
            dataIndex: '',
            render: (detail: IFormRelated) => (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <ButtonGrid color={COLORS.black_text_color4} active={(formLoading || (!compareFormRelated(detail, detailUpdate) && !!detailUpdate)) ? false : true} icon={compareFormRelated(detail, detailUpdate) ? <RollbackOutlined /> : <FormOutlined />} method={() => selectDetail(detail)} />
                    <nav>&nbsp;&nbsp;</nav>
                    <ButtonGrid color={COLORS.black_text_color4} active={(formLoading || !!detailUpdate) ? false : true} icon={<DeleteOutlined />} method={() => removeDetail(detail)} />
                </div>
            )
        }
    ];

    // Methods
    const validations = (values: any) => {
        const errors: any = {};
        if (formQuestion?.visualizacionTipoNombre !== VisualizacionFormulario.Tabla && !values.listadoID) {
            errors.listadoID = 'Requerido';
        }

        if (!values.departamentoGUID) {
            errors.departamentoGUID = 'Requerido';
        }

        if (!values.GrupoUsuarioID && !values.UsuarioGUID) {
            errors.UsuarioGUID = 'Requerido';
            errors.GrupoUsuarioID = 'Requerido';
        }

        return errors;
    };

    const compareFormRelated = (form1: IFormRelated, form2?: IFormRelated) => {

        if (`${form1.listadoID}${form1.formularioListadoUsuario[0].usuarioGUID}${form1.formularioListadoUsuario[0].grupoUsuarioID}` === `${form2?.listadoID}${form2?.formularioListadoUsuario[0].usuarioGUID}${form2?.formularioListadoUsuario[0].grupoUsuarioID}`) {
            return true;
        }

        return false;
    }

    const comparteFormRelatedDetail = (form1: IFormRelated, form2?: IFormRelated) => {

        if (form1.listadoID === form2?.listadoID &&
            (
                (form2.formularioListadoUsuario[0].usuarioGUID != null && form1.formularioListadoUsuario[0].usuarioGUID === form2.formularioListadoUsuario[0].usuarioGUID) ||
                (form2.formularioListadoUsuario[0].grupoUsuarioID != null && form1.formularioListadoUsuario[0].grupoUsuarioID === form2.formularioListadoUsuario[0].grupoUsuarioID)
            )) {
            return true;
        }

        return false;
    }

    const selectDetail = (detail: IFormRelated) => {
        if (!detailUpdate) {
            setDetailUpdate(detail);
            setDetailPosition(listFormRelated.findIndex(item => compareFormRelated(item, detail)));

            ListRelatedForm.setValues({
                listadoID: (detail.listadoID || '').toString(),
                UsuarioGUID: detail.formularioListadoUsuario[0].usuarioGUID || '',
                GrupoUsuarioID: detail.formularioListadoUsuario[0].grupoUsuarioID?.toString() || '',
                departamentoGUID: detail.formularioListadoUsuario[0].departamentoGUID || '',
            });

        } else {
            clearForm();
        }
    }

    const addDetail = () => {
        const newDetail: IFormRelated = {
            formularioListadoID: 0,
            formularioID: formQuestion?.formularioID!,
            formularioNombre: formQuestion?.nombre!,
            listadoIDInicial: 0,
            listadoID: parseInt(ListRelatedForm.values.listadoID) || null,
            listadoNombre: listbase.find(base => base.listadoID === parseInt(ListRelatedForm.values.listadoID))?.nombre!,
            formularioListadoUsuario: [{
                formularioListadoUsuarioID: 0,
                formularioListadoID: 0,
                grupoUsuarioID: parseInt(ListRelatedForm.values.GrupoUsuarioID) || null,
                usuarioGUID: ListRelatedForm.values.UsuarioGUID || null,
                departamentoGUID: ListRelatedForm.values.departamentoGUID || null
            }]
        };

        if (listFormRelated.some(item => comparteFormRelatedDetail(item, newDetail))) {
            openNotification('error', 'Ya existe', `El usuario o Grupo Usuario ya están asignados a este listado`);
        } else {
            setListFormRelated([...listFormRelated, newDetail]);
            clearForm();
        }
    }

    const updateDetail = () => {
        const newDetail: IFormRelated = {
            ...detailUpdate!,
            listadoID: parseInt(ListRelatedForm.values.listadoID) || null,
            listadoNombre: listbase.find(base => base.listadoID === parseInt(ListRelatedForm.values.listadoID))?.nombre!,
            formularioListadoUsuario: [{
                formularioListadoUsuarioID: 0,
                formularioListadoID: 0,
                grupoUsuarioID: parseInt(ListRelatedForm.values.GrupoUsuarioID) || null,
                usuarioGUID: ListRelatedForm.values.UsuarioGUID || null,
                departamentoGUID: ListRelatedForm.values.departamentoGUID || null
            }]
        };

        const found = listFormRelated.findIndex(item => comparteFormRelatedDetail(item, newDetail));

        if (found !== -1 && found !== detailPosition) {
            openNotification('error', 'Ya existe', `El usuario o Grupo Usuario ya están asignados a este listado`);
        } else {
            let listInternal = listFormRelated;
            listInternal[detailPosition!] = newDetail;

            setListFormRelated([...listInternal]);
            clearForm();
        }
    }

    const removeDetail = (detail: IFormRelated) => {
        const list = listFormRelated.filter(item => !compareFormRelated(item, detail));
        setListFormRelated(list);
    }


    const clearForm = () => {
        ListRelatedForm.resetForm();
        setDetailUpdate(undefined);
        setDetailPosition(null);
    }

    const makeFormRelatedListPlane = (formRelatedList: IFormRelated[]) => {
        const list: IFormRelated[] = [];
        formRelatedList.forEach(form => {
            form.formularioListadoUsuario.forEach(detail => {
                if (detail.usuarioGUID != null && detail.usuarioGUID != "" ){
                    detail.departamentoGUID = (listUserAll.find(user => user.usuarioGUID === detail.usuarioGUID)?.usuarioProyecto?.departamentoGUID) || '';
                }
                else
                {
                    detail.departamentoGUID = (listUserGroupAll.find(user => user.grupoUsuarioID === detail.grupoUsuarioID)?.departamentoGUID) || '';
                }
                list.push({
                    ...form,
                    listadoIDInicial: form.listadoID,
                    formularioListadoUsuario: [detail]
                });
            })
        })

        return list;
    }

    const MakeFormRelatedListUnplaned = (formRelatedList: IFormRelated[]) => {
        const list: IFormRelated[] = [];
        const groupListId: any[] = [];

        formRelatedList.forEach(form => {
            if (!groupListId.includes(form.listadoID)) {
                groupListId.push(form.listadoID);
            }
        });

        groupListId.forEach(listId => {
            var formListInicial = formRelatedList.filter(form => form.listadoIDInicial === listId);
            const formList = formRelatedList.filter(form => form.listadoID === listId);

            if (formListInicial.length === 0) {
                formListInicial = formRelatedList.filter(form => form.listadoIDInicial === 0 && form.listadoID === listId);
            }
            
            if (formListInicial.length !== 0) {
                const formRelated: IFormRelated = {
                    ...formListInicial[0],
                    formularioListadoUsuario: []
                }

                if (formRelated.listadoIDInicial !== 0) {
                    formRelated.listadoID = formRelated.listadoIDInicial;
                }              

                formList.forEach(form => {
                    formRelated.formularioListadoUsuario.push(form.formularioListadoUsuario[0]);
                })
    
                list.push(formRelated);
            }            
        })

        return list;
    }

    // Handles
    const handleSubmit = () => {
        tryCatch(() => {
            setFormLoading(true);
            const unPlanedListFormRelated = MakeFormRelatedListUnplaned(listFormRelated);

            UpdateListByFormID(formQuestion?.formularioID!, unPlanedListFormRelated)
                .then((response) => {
                    openNotification('success', `Formulario Modificado`, response.msg!);
                    setRelateUserModal(false);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setFormLoading(false));
        })
    }

    // Form
    const ListRelatedForm = useFormik({
        initialValues: { listadoID: '', UsuarioGUID: '', GrupoUsuarioID: '', departamentoGUID: formQuestion?.departamentoGUID },
        validate: validations,
        onSubmit: (values) => !!detailUpdate ? updateDetail() : addDetail()
    });


    // Effects
    useEffect(() => {
        tryCatch(() => {
            if (formQuestion != null && !loadingUserAll && !loadingUserGroupAll && !loadingDeparmentAll)
            {
                getListByFormID(formQuestion.formularioID)
                .then((response) => {
                    const result = makeFormRelatedListPlane(response.data);
                    setListFormRelated(result);
                })
            }            
        });
    }, [formQuestion, loadingUserAll, loadingUserGroupAll, loadingDeparmentAll])
    
    return (
        <ModalContainer>

            <GroupRow>
                <MarginInput width="100%">
                    <label>Listado:</label>
                    <SelectBox
                        value={ListRelatedForm.values.listadoID}
                        placeholder={"Listado"}
                        disabled={formQuestion?.visualizacionTipoNombre === VisualizacionFormulario.Tabla}
                        allowClear={false}
                        loading={loadingListBase}
                        onChange={(value: string) => ListRelatedForm.setFieldValue('listadoID', value)}
                        options={listbase.filter(base => base.departamentoGUID === formQuestion?.departamentoGUID).map(base => ({ key: base.listadoID + base.nombre!, value: base.listadoID.toString(), text: base.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListRelatedForm.errors.listadoID && ListRelatedForm.errors.listadoID}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="100%">
                    <label>Departamento:</label>
                    <SelectBox
                        value={ListRelatedForm.values.departamentoGUID}
                        placeholder={"Departamento"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingDeparmentAll}
                        onChange={(value: string) => { ListRelatedForm.setValues({ ...ListRelatedForm.values, departamentoGUID: value, UsuarioGUID: "", GrupoUsuarioID: "" }) }}
                        options={listDepartmentAll.map(dep => ({ key: dep.departamentoGUID, value: dep.departamentoGUID, text: dep.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListRelatedForm.errors.departamentoGUID && ListRelatedForm.errors.departamentoGUID}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="45%">
                    <label>Usuario:</label>
                    <SelectBox
                        value={ListRelatedForm.values.UsuarioGUID}
                        placeholder={"Usuario"}
                        disabled={!!ListRelatedForm.values.GrupoUsuarioID}
                        allowClear={true}
                        loading={loadingUserAll}
                        onChange={(value: string) => ListRelatedForm.setFieldValue('UsuarioGUID', value)}
                        options={listUserAll.filter(user => user.usuarioProyecto?.departamentoGUID === ListRelatedForm.values.departamentoGUID).map(user => ({ key: user.usuarioID + user.usuarioGUID, value: user.usuarioGUID, text: `${user.nombreUsuario} - ${user.primerNombre} ${user.primerApellido}` }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListRelatedForm.errors.UsuarioGUID && ListRelatedForm.errors.UsuarioGUID}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Grupo Usuario:</label>
                    <SelectBox
                        value={ListRelatedForm.values.GrupoUsuarioID}
                        placeholder={"Grupo Usuario"}
                        disabled={!!ListRelatedForm.values.UsuarioGUID}
                        allowClear={true}
                        loading={loadingUserGroupAll}
                        onChange={(value: string) => ListRelatedForm.setFieldValue('GrupoUsuarioID', value)}
                        options={listUserGroupAll.filter(group => group.departamentoGUID === ListRelatedForm.values.departamentoGUID).map(group => ({ key: group.grupoUsuarioID + group.nombre, value: group.grupoUsuarioID?.toString(), text: group.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListRelatedForm.errors.GrupoUsuarioID && ListRelatedForm.errors.GrupoUsuarioID}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>


            <div style={{ marginTop: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
                    <MarginInput width="40%">
                        <OutLineButton color={!!detailUpdate ? COLORS.white_color1 : COLORS.blue_active} backgroundColor={!!detailUpdate ? COLORS.blue_main(1) : COLORS.transparent_color1} text={(!!detailUpdate ? "Modificar" : "Añadir") + " Listado - Usuario"} method={ListRelatedForm.handleSubmit} />
                    </MarginInput>
                </div>
                <DetailTable
                    props={{ rowKey: (record: IFormRelated) => record.listadoNombre + record.formularioListadoUsuario[0].grupoUsuarioID + record.formularioListadoUsuario[0].usuarioGUID }}
                    dataSource={listFormRelated}
                    columns={columns}
                    loading={false}
                    paginationActive={!detailUpdate}
                />
            </div>

            <ModalBtnCotainer>
                <LoadingButton
                    type="button"
                    disabled={listFormRelated.length < 1 || !!detailUpdate}
                    method={handleSubmit}
                    title={"Guardar"}
                    loading={formLoading.toString()}
                    background={COLORS.blue_active}
                    color={COLORS.white_color1}
                    style={{ padding: '3px', width: '200px', margin: 'auto', height: '32px' }}
                    fontsize={16}
                />
            </ModalBtnCotainer>
        </ModalContainer>
    );
}


export default RelacionarListadoUsuario;